import { BaseApi } from './base';

class StudyingProgramsApi extends BaseApi {
  constructor() {
    super('admin/program/programs');
  }

  getPrograms() {
    return this.get('')
  }

  createOrUpdateProgram(data) {
    return this.post('', data)
  }

  removeProgram(id) {
   return this.delete(`/${id}`)
  }
}

export default new StudyingProgramsApi();
